import styled from 'styled-components'
import { grayLightest } from 'utils/style-utils'

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  height: 2rem;
  margin-bottom: 1rem;
  align-items: center;
`

export const CategoryLabel = styled.label`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${grayLightest};
  cursor: pointer;
`

interface Props {
  rows: number
}

export const GamesGridBox = styled.div.withConfig<Props>({
  shouldForwardProp: (prop: string): boolean => !prop.includes('rows'),
})`
  display: grid;
  grid-template-rows: repeat(${({ rows }) => rows}, 1fr);

  margin: -2.5rem -1rem 1rem;
  padding: 2rem 0 0.5rem;
`
